module.exports = __webpack_public_path__ + "img/max-file-content-signature--deny.2e181502.svg";